import { Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { DutiesService } from '../services/duties.service';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DepartmentService } from '../../location/services/department.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { SpinnerComponent } from '../../../../shared/component/spinner/spinner.component';
import { AddDutyComponent } from '../add-duty/add-duty.component';
import { PromptDialogComponent } from '../../../../shared/component/prompt-dialog/prompt-dialog.component';
import { customPatternValidator } from '../../../../shared/custom-validator/pattern-validator';
import { finalize, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { ManageDialogComponent } from '../../../../shared/component/manage-dialog/manage-dialog.component';
import { UserOrgService } from 'src/app/shared/service/user-org.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { PERMISSIONS } from 'src/app/constants/permissions.constants';
import { TranslateService } from '@ngx-translate/core';
import { DutyDetailsComponent } from '../duty-details/duty-details.component';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';

@Component({
  selector: 'app-map-duty',
  templateUrl: './map-duty.component.html',
  styleUrl: './map-duty.component.scss',
})
export class MapDutyComponent implements OnInit, OnDestroy {
  @ViewChildren('dutyRowElem') rowElements!: QueryList<ElementRef>;
  @ViewChildren('memberTypeSelect') memberTypeSelects!: QueryList<MatSelect>;
  private destroy$ = new Subject<void>();
  editExpansionData: any;
  dutyTableData: any;
  canEditDuty:boolean=false;
  canMapDuty:boolean=false;
  activateForm = this._formBuilder.group({
    active: true,
  });  
  selectedDutyDetails: any;
  selectedDepts: any;
  selectedMonth: any;
  month: any;
  year: any;
  selMonthYear: any;
  planningSheetPublished: boolean = false;
  planningSheetSaved: boolean = false;
  displayedColumns: string[] = [
    'memberType',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  // columnsToDisplayWithExpand = [...this.displayedColumns, 'more'];
  selectedDept: any;
  selectedDeptLength: number = 0;
  departmentList: any[] = [];
  monthYear: any;
  dataSource = new MatTableDataSource<any>();
  selectedValues: any[] = [];
  memberTypeList: any[] = [];
  dutyChartForm!: FormGroup;
  editMode: boolean[] = [];
  activeMember: boolean = true;
  disableButton: boolean = true;
  editMemberData: any;
  showMemberData: boolean = true;
  prevMonth = new FormControl({ value: '', disabled: true });
  prevMonthList: any;
  dutyDeptId: any;
  selectedPrevMonth: any;
  isPrevMonth: boolean = false;
  selectedDutyName: string = '';
  selMonth: any;
  selectedMonthInt: number;
  configManually: boolean = true;
  loadFromPrev: boolean = false;
  configdisable: boolean = false;
  isEdit: boolean = false;
  selectedMonthForListing: Date = new Date();
  enableDutyMap: boolean = true;
  disableMemberType: boolean = false;
  editMemberType: boolean[] = [];
  selectedLocId:any
  orgId: string | null = this._userOrgService.getOrgId() ?? sessionStorage.getItem('orgId');
  validMemberRow: boolean = false
  dutyPublished:boolean = false
  dutyFormMonth:any;
  shiftTypeLabels: { [key: string]: string } = {
    FULL_DAY_DUTY: 'duties.shift_types.full_day',
    FIRST_HALF_DAY_DUTY: 'duties.shift_types.left_half',
    SECOND_HALF_DAY_DUTY: 'duties.shift_types.right_half'
  };
  availableShiftTypes: string[] = [];
  isSingleShiftType: boolean = false;
  onlyShiftTypeLabel: string = '';
  isDutyMapped: boolean = false;
  isManager:boolean | null;
  loadDetails: boolean = true;
  showMemberRowDelete: boolean[] = []; // show delete option against membertype row for unsaved planning sheet
  hasRowRemoved: boolean = false;
  noSavedConfigurations: boolean = false;
  isAppAdmin: boolean = false;
  loadingMemberTypes = false;
  initialMemberRowLen: number = 0 //number members mapped to the duty before deletion 
  constructor(
    public dialogRef: MatDialogRef<MapDutyComponent>,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public editFormData: any,
    public dutiesService: DutiesService,
    public sharedDataService: SharedDataService,
    public deptservice: DepartmentService,
    private _userOrgService: UserOrgService,
    private permissionsService: PermissionsService,
    public translateService: TranslateService,
    private planningDataService: PlanningDataService
  ) {
    this.dutyChartForm = this._formBuilder.group({
      dutyRows: this._formBuilder.array([]),
      department: ['', Validators.required],
      month: ['', Validators.required],
    });
    if (this.dutyChartForm.valueChanges) {
      this.dutyChartForm.valueChanges.subscribe((value) => {
        this.handleMemberDataChange(value);
      });
    }
  }

  get dutyRows(): FormArray {
    return this.dutyChartForm.get('dutyRows') as FormArray;
  }

  //show delete column conditionally
  get columnsToDisplayWithExpand(): string[] {
    let columns = [...this.displayedColumns, 'more'];

    // ✅ Show delete column if ANY row is true and other conditions are met
    const shouldShowDelete =
      this.showMemberRowDelete?.some((val) => val) &&
      !this.planningSheetPublished &&
      !this.planningSheetSaved;

    if (shouldShowDelete) {
      columns.push('delete');
    }

    return columns;
  }

  ngOnInit() {
    this.selectedLocId = typeof window !== 'undefined' && window.sessionStorage ? sessionStorage.getItem('userLocationId'): null;
    if(this.editFormData.locationId){
      this.sharedDataService.locationId = this.editFormData.locationId
    }
    combineLatest([
      this.permissionsService.userPermissions$,
      this.permissionsService.currentPermissions$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([userPermissions, currentPermissions]) => {
      this.canEditDuty=this.editFormData?.globalEdit
        ? userPermissions.includes(PERMISSIONS.GLOBAL_DUTY_MANAGEMENT_WRITE)
        : currentPermissions.includes(PERMISSIONS.DUTY_MANAGEMENT_WRITE);
      this.canMapDuty=this.editFormData?.globalEdit
        ? userPermissions.includes(PERMISSIONS.DUTY_DEPARTMENT_MAPPING_WRITE)
        : currentPermissions.includes(PERMISSIONS.DUTY_DEPARTMENT_MAPPING_WRITE);
       if (this.editFormData?.isMapDutyReadOnlyDepAdmin === true) {
         //if the department id of the deptadmin dont match, then it is readonly user
         this.canMapDuty = false;
       }
       if (this.editFormData?.isEditDutyReadOnlyDepAdmin === true) {
         //if the department id of the deptadmin dont match, then it is readonly user
         this.canEditDuty = false;
       }
      });
    if (this.permissionsService.getUserRole && this.permissionsService.getUserRole() === 'APP_ADMIN') {
      this.isAppAdmin = true;
    } 
    if (this.editFormData) {
      this.selectedMonthInt =  this.editFormData.selectedMonthInt
      this.dutyPublished = this.editFormData?.planningSheetPublished
      if(this.dutyPublished && !this.isAppAdmin){
        this.activateForm.get('active')?.disable();
      }
      else{
        this.activateForm.get('active')?.enable();
      }
      if(this.editFormData.editId) { this.dutyInfo(this.editFormData.editId) }
      let translatedMonth
      if(this.editFormData?.editDutyId){
      this.isEdit = true;
      this.dutyFormMonth = this.editFormData.month;
      this.translateService
      .get("months."+this.editFormData.month)
      .subscribe((translatedText: string) => {
        translatedMonth = translatedText;
      });
        this.dutyChartForm
        .get('month')
        ?.setValue(
          `${translatedMonth} ${this.editFormData?.year}`
        );
      }
      else{
      this.dutyFormMonth = this.editFormData.selectedMonth
         this.translateService
      .get("months."+this.editFormData.selectedMonth)
      .subscribe((translatedText: string) => {
        translatedMonth = translatedText;
      });
        this.dutyChartForm
        .get('month')
        ?.setValue(
          `${translatedMonth} ${this.editFormData?.selectedYear}`
        );
      this.getDeptData();
      }
      this.dutyChartForm.get('month')?.disable();
      // this.getDeptData();
    }
    // this.getMemberTypeData();
  }

  getDeptData() {
    this.deptservice
      .fetchDepartments(this.sharedDataService.locationId)
      .subscribe((deptData) => {
        if (deptData.status === 200) {
          this.departmentList = deptData.body;
          this.selectedDept = this.departmentList?.filter((dept: { id: any }) =>
            this.editFormData?.selectedDept?.id.includes(dept.id)
          );
          this.dutyChartForm.get('department')?.setValue(this.selectedDept[0]?.name);
          this.selectedDeptLength = this.selectedDept.length;
          this.dutyChartForm.get('department')?.disable();
        }
      });
  }

  getMemberTypeData(emitData?: any) {
    const params: any = {};
    if (this.isManager !== null) {
      params.isManager = this.isManager;
    }
    this.loadingMemberTypes = true; // start loader
    this.deptservice
      .fetchOrgMemberTypes(this.orgId,params)
      .subscribe({next: (memberData: any) => {
        if (memberData.status === 200) {
          this.memberTypeList = memberData.body;
          this.sharedDataService.updateMemberTypeData(memberData.body);
          if (emitData) {
            emitData.componentInstance.updatedDataList(memberData.body);
          }
        }
      },
      error: (err) => {
        console.error('Error fetching member types', err);
        this.loadingMemberTypes = false;
      },
      complete: () => {
        this.loadingMemberTypes = false; // stop loader
      },
      });
  }

  getFormData() {
    if (this.editFormData.editDutyId) {
      this.dutyDeptId = this.editFormData.editDutyId;
      this.dutyChartForm.get('department')?.disable();
      this.selectedMonthForListing = this.editFormData.selectedMonth;
      this.isEdit = true;
      this.getMonthAndDutyDetails(
        this.editFormData.editDutyId,
        this.editFormData.editDutyId,
        'edit'
      );
    } else if (this.editFormData.selectedDutyId) {
      this.isEdit = false;
      this.selectedMonthForListing = this.editFormData.month;//so that in further execution, it checks for previous month cases for disabling fields.
      if (this.sharedDataService.locationId) {
        //get unmapped departments for the selected duty
        this.dutiesService
          .fetchUnmappedDepts(
            this.sharedDataService.locationId,
            this.editFormData.selectedDutyId,
            false
          )
          .subscribe((deptData) => {
            if (deptData.status === 200) {
              this.departmentList = deptData.body;
            }
          });
      }
      this.dutyDeptId = this.editFormData.selectedDutyId;
      this.getMonthAndDutyDetails('', this.editFormData.selectedDutyId);
      this.memberTypeTable();
    }
  }

  getMonthAndDutyDetails(
    monthYearParam: any,
    dutyDetailsParam: any,
    action?: string
  ) {
    this.fetchMonthYear(monthYearParam);
    this.fetchDutyDetails(dutyDetailsParam, action);
  }

  fetchMonthYear(id: any) {
    this.dutiesService.fetchMonthYear(id).subscribe((data) => {
      if (data.status === 200) {
        this.monthYear = data.body;
        if (this.editFormData.editId) {//uppdated editDutyId with editId so that it checks for both mapped as well as not mapped cases(for previous month checks also).
          this.getCurrentMonth();
        }
        this.prevMonthList = this.monthYear
          ?.filter((item: { available: any }) => item.available)
          ?.map((item: any) => {
            const [month, year] = item?.monthYear?.split(' ');
            return { month, year };
          });
      }
    });
  }

  //find the current month and make api call to fetch current month duty mapping data
  getCurrentMonth() {
    if (!this.selectedMonthForListing) {
      return; // exit early
    }
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
    };
    const formattedDate = this.selectedMonthForListing.toLocaleDateString(
      undefined,
      options
    );
    const foundItem = this.monthYear.find(
      (item: any) => item.monthYear === formattedDate
    );
    if (foundItem && this.editFormData.editDutyId) {// only if it is editing mode
      this.selectedMonth = formattedDate; //  'September 2024'
      this.dutyChartForm.get('month')?.setValue(formattedDate);
      this.dutyChartForm.get('month')?.disable();
      let monthChangeParam = {
        value: formattedDate,
      };
      this.monthYear = [{ monthYear: formattedDate }];
      this.onMonthChange(monthChangeParam);
    }else{//if any invalid months are choosen, then show this message
      this.previousMonthCheck(formattedDate);
    }
  }

  fetchDutyDetails(id: any, action?: 'edit' | string): void {
    this.loadDetails = true;
    if (action === 'edit') {
      this.dutiesService.fetchMappedDutyDetails(id).pipe(
        tap((res: any) => {
          if (res.status === 200) {
            const body = res.body;
            this.isDutyMapped = true;
            this.mapDutyDetails(body, true, id);
          }
        }),
        mergeMap(() => this.dutiesService.fetchUnmappedDepts(
          this.sharedDataService.locationId,
          this.editFormData.editId,
          true
        )),
        takeUntil(this.destroy$),
        finalize(() => this.loadDetails = false) 
      ).subscribe({
        next: (deptRes: any) => {
          if (deptRes.status === 200) {
            this.departmentList = deptRes.body;
            this.selectedDept = this.departmentList?.filter((dept: { id: any }) =>
              this.selectedDutyDetails?.departmentId?.includes(dept.id)
            );
            this.dutyChartForm.get('department')?.setValue(this.selectedDept?.[0]?.name || '');
            this.selectedDeptLength = this.selectedDept?.length ?? 0;
          }
        },
        error: () => { /* optionally handle error */ }
      });

    } else {
      this.dutiesService.fetchSingleDutyById(id).pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loadDetails = false)
      ).subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.isDutyMapped = !!res.body?.isDutyMappedToAnyLocationDepartment;
            this.mapDutyDetails(res.body, false, id);
          }
        },
        error: () => { /* optionally handle error */ }
      });
    }
  }

  private mapDutyDetails(body: any, isMapped: boolean, incomingShiftDutyId: string): void {
    if (!body) return;

    // Find the exact shift by shiftDutyId
    const matchingShift = body.shifts?.find((shift: any) => shift.shiftDutyId === incomingShiftDutyId);

    // If not found, fallback to FULL_DAY_DUTY or the first shift
    const shift = matchingShift || body.shifts?.find((s: any) => s.shiftType === 'FULL_DAY_DUTY') || body.shifts?.[0];

    const mappedFields = {
      firstSlotStartTime: this.sharedDataService.convertTo24HourFormat(shift?.firstSlotStartTime),
      firstSlotEndTime: this.sharedDataService.convertTo24HourFormat(shift?.firstSlotEndTime),
      secondSlotStartTime: this.sharedDataService.convertTo24HourFormat(shift?.secondSlotStartTime),
      secondSlotEndTime: this.sharedDataService.convertTo24HourFormat(shift?.secondSlotEndTime),
    };

    this.selectedDutyDetails = {
      ...body,
      ...shift,
      ...mappedFields,
    };

    this.selectedDutyName = isMapped ? body.dutyName : body.name;
  }

  cancelForm() {
    if (this.dutyChartForm.dirty) {
      this.showWarningMessageDialog();
    } else {
      this.onNoClick();
    }
  }
  onNoClick() {
    this.dialogRef.close(this.hasRowRemoved && this.noSavedConfigurations ? 'update':'close');
  }

  showWarningMessageDialog() {
    const dialogRef: MatDialogRef<PromptDialogComponent> = this.dialog.open(
      PromptDialogComponent,
      {
        width: '536px',
        height: '338px',
        disableClose: true,
        data: {
          iconName: 'info',
          title: 'prompt_dialog.title',
          message: 'prompt_dialog.content',
          buttons: ['prompt_dialog.back_btn', 'prompt_dialog.ok_btn'],
          buttonName: ['Back', 'OK'],
        },
      }
    );
    dialogRef.componentInstance.buttonClicked.subscribe(
      (buttonName: string) => {
        if (buttonName === 'OK') {
          dialogRef.close();
          this.onNoClick();
        } else if (buttonName === 'Back') {
          dialogRef.close();
        }
      }
    );
  }

  onMonthChange(event: any) {
    this.selMonth = event.value;
    let year = event.value.replace(' ', '_');
    this.selMonthYear = year;
    this.selectedValues = [];
    this.editMode = [];
    if (this.editFormData.editDutyId) {
      this.dutiesService
        .fetchMonthYearMemberData(this.editFormData.editDutyId, this.selectedMonthInt, this.year)
        .pipe(takeUntil(this.destroy$))
        .subscribe((memberTypeData) => {
          if (memberTypeData.status === 200) {
            if (memberTypeData.body) {
              this.editMemberData = memberTypeData.body?.dutyMemberTypes;
              this.showMemberRowDelete = this.editMemberData.map(() => true);
              this.enableDutyMap = memberTypeData?.body?.active;
              this.planningSheetPublished =
                memberTypeData?.body?.planningSheetPublished !== null
                  ? memberTypeData?.body?.planningSheetPublished
                  : false;
              this.planningSheetSaved =
                memberTypeData?.body?.planningSheetSaved !== null
                  ? memberTypeData?.body?.planningSheetSaved
                  : false;
              if(this.isEdit){
                this.disableMemberType = true;
                this.editMemberDataForm(true, 'showName');
              } else{
                this.disableMemberType = false;
                this.editMemberDataForm(true, 'showId');
              }
              if (this.editMemberData?.length > 0) {
                this.showMemberData = true;
                this.previousMonthCheck(event?.value);
              } else {
                this.previousMonthCheck(event.value);
                if (!this.isPrevMonth) {
                  this.showMemberData = false;
                  this.editFormData.button =
                    'duties.map_duty_dialog.action.continue_setup_btn';
                  this.editFormData.buttonName = 'Continue Setup';
                  this.editFormData.cancelBtn =
                    'duties.map_duty_dialog.action.close_btn';
                } else {
                  this.showMemberData = true;
                }
              }
            }
          } else {
            this.memberTypeTable();
            this.previousMonthCheck(event.value);
          }
        });
    } else {
      this.previousMonthCheck(event.value);
    }
  }

  previousMonthCheck(date: any) {
    // Parse the input string to get the month and year
    const [month, yearStr] = date.split(' ');
    const year = parseInt(yearStr, 10);

    // Create a Date object for the first day of the given month and year
    const inputDate = new Date(`${month} 1, ${year}`);

    // Get the current date
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // getMonth() is zero-based

    // Create a Date object for the first day of the current month and year
    const currentMonthStartDate = new Date(currentYear, currentMonth, 1);

    // Compare the dates
    this.isPrevMonth = inputDate < currentMonthStartDate;
    if((this.planningSheetPublished||this.isPrevMonth||!this.canMapDuty||(!this.editFormData.editDutyId && this.dutyPublished)) && !this.isAppAdmin){//!this.editFormData.editDutyId && this.dutyPublished-create mode with published planning sheet
      this.disableAllFields();
    }
  }

  disableAllFields() {
    const dutyRows = this.dutyChartForm.get('dutyRows') as FormArray;
    if (!this.planningSheetPublished && !this.isPrevMonth && this.canMapDuty && (this.editFormData?.editDutyId || !this.dutyPublished) ) {
      if (!this.isPrevMonth && this.editFormData.editDutyId) {
        dutyRows.enable();
        this.editFormData.button = 'duties.map_duty_dialog.action.save_btn';
        this.editFormData.buttonName = 'Save';
      } else if (!this.isPrevMonth && this.editFormData.selectedDutyId) {
        dutyRows.enable();
        this.editFormData.button = 'duties.map_duty_dialog.action.create_btn';
        this.editFormData.buttonName = 'Create';
      }
    } else {//provide read only mode if planning sheet is published,have no rights to map duty 
    // or if the selected month is previous month(in all of these cases, it skips the if part and enters the else part)
      dutyRows.disable();
      this.activateForm.get('active')?.disable();
      this.editFormData.button = 'duties.map_duty_dialog.action.close_btn';
      this.editFormData.buttonName = 'Close';
    }
  }

  //show membertype table on add duty
  memberTypeTable() {
    this.clearDutyRows();
    let newRow;
    newRow = this._formBuilder.group({
      memberTypeId: new FormControl({ value: '', disabled: !this.canMapDuty }, Validators.required),
      monday: new FormControl({ value: '', disabled: !this.canMapDuty }, customPatternValidator('numeric', 'monday')),
      tuesday: new FormControl(
        { value: '', disabled: !this.canMapDuty },
        customPatternValidator('numeric', 'tuesday')
      ),
      wednesday: new FormControl(
        { value: '', disabled: !this.canMapDuty },
        customPatternValidator('numeric', 'wednesday')
      ),
      thursday: new FormControl(
        { value: '', disabled: !this.canMapDuty },
        customPatternValidator('numeric', 'thursday')
      ),
      friday: new FormControl({ value: '', disabled: !this.canMapDuty }, customPatternValidator('numeric', 'friday')),
      saturday: new FormControl(
        { value: '', disabled: !this.canMapDuty },
        customPatternValidator('numeric', 'saturday')
      ),
      sunday: new FormControl({ value: '', disabled: !this.canMapDuty }, customPatternValidator('numeric', 'sunday')),
      active: new FormControl(true),
    });
    (this.dutyChartForm.get('dutyRows') as FormArray).push(newRow);
    this.dataSource = new MatTableDataSource(
      (this.dutyChartForm.get('dutyRows') as FormArray).controls
    );
    this.editMode.push(false);
    this.editMemberType.push(true)
  }

  //show existing member type table data
  editMemberDataForm(disableMemberType?: boolean, type?: string) {
    this.clearDutyRows();
    let newRow;
    for (let i = 0; i < this.editMemberData?.length; i++) {
      newRow = this._formBuilder.group({
        id: this.editMemberData[i]?.id,
        memberId: this.editMemberData[i]?.memberTypeId,
        memberTypeId: {
          value:
            type === 'showName'
              ? this.editMemberData[i]?.memberType
              : this.editMemberData[i]?.memberTypeId,
          disabled: disableMemberType,
        },
        monday: [{ value: this.editMemberData[i]?.monday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'monday')],
        tuesday: [{ value: this.editMemberData[i]?.tuesday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'tuesday')],
        wednesday: [{ value: this.editMemberData[i]?.wednesday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'wednesday')],
        thursday: [{ value: this.editMemberData[i]?.thursday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'thursday')],
        friday: [{ value: this.editMemberData[i]?.friday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'friday')],
        saturday: [{ value: this.editMemberData[i]?.saturday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'saturday')],
        sunday: [{ value: this.editMemberData[i]?.sunday, disabled: !this.canMapDuty }, customPatternValidator('numeric', 'sunday')],
        active: this.editMemberData[i]?.active,
      });
      (this.dutyChartForm.get('dutyRows') as FormArray).push(newRow);
      this.dataSource = new MatTableDataSource(
        (this.dutyChartForm.get('dutyRows') as FormArray).controls
      );
      this.dutyTableData = this.dutyChartForm.value.dutyRows;
      this.editMode[i] = true;
      this.editMemberType[i] = false
      this.onOptionSelection();
    }
  }

  clearDutyRows() {
    while (this.dutyRows.length !== 0) {
      this.dutyRows.removeAt(0);
    }
    this.dataSource = new MatTableDataSource(this.dutyRows.controls);
  }

  loadPrev(event: any) {
    if (event.value === 'loadPrev') {
      this.prevMonth.enable();
      this.prevMonth.setValidators(Validators.required);
      this.prevMonth.updateValueAndValidity();
      this.configdisable = true;
    }
  }

  config(event: any) {
    this.loadFromPrev = false;
    this.configManually = true;
    if (event.value === 'config') {
      this.prevMonth.disable();
      this.prevMonth.clearAsyncValidators();
      this.prevMonth.updateValueAndValidity();
      this.configdisable = false;
    }
  }
  onPrevMonthChange(event: any) {
    this.configManually = false;
    this.loadFromPrev = true;
    let y = `${event.value.month}_${event.value.year}`;
    this.selectedPrevMonth = y;
    if (this.selectedPrevMonth) {
      this.configdisable = false;
    } else {
      this.configdisable = true;
    }
  }

  loadMemberDataOfPrevMonth() {
    this.dutiesService
      .fetchPrevMonthMemberData(this.dutyDeptId, this.selectedMonthInt, this.year)
      .subscribe((prevMonthData: any) => {
        if (prevMonthData.status === 200) {
          if (prevMonthData.body && prevMonthData.body.length > 0) {
            this.editFormData.buttonName = 'Save';
            this.editFormData.button = 'duties.map_duty_dialog.action.save_btn';
            this.showMemberData = true;
            let newRow;
            for (let i = 0; i < prevMonthData?.body?.length; i++) {
              newRow = this._formBuilder.group({
                memberTypeId: [{ value: prevMonthData.body[i]?.memberTypeId }],
                monday: prevMonthData.body[i]?.monday,
                tuesday: prevMonthData.body[i]?.tuesday,
                wednesday: prevMonthData.body[i]?.wednesday,
                thursday: prevMonthData.body[i]?.thursday,
                friday: prevMonthData.body[i]?.friday,
                saturday: prevMonthData.body[i]?.saturday,
                sunday: prevMonthData.body[i]?.sunday,
                active: true,
              });
              (this.dutyChartForm.get('dutyRows') as FormArray).push(newRow);
              this.dataSource = new MatTableDataSource(
                (this.dutyChartForm.get('dutyRows') as FormArray).controls
              );
              this.editMode[i] = false;
              this.onOptionSelection();
            }
          }
        }
      });
  }

  handleMemberDataChange(event: any) {
    this.selectedDepts = this.dutyChartForm?.value?.department;
    this.selectedMonth = this.dutyChartForm?.value?.month;
    const splitSelectedMonth = this.selectedMonth?.split(' ');
    if (splitSelectedMonth) {
      this.month = this.dutyFormMonth;
      this.year = splitSelectedMonth[1];
    }
    if (this.dutyChartForm.value.dutyRows) {
      for (let row of this.dutyChartForm?.value?.dutyRows) {
        for (let key in row) {
          if (row[key] !== '') {
            this.dutyChartForm
              ?.get('memberTypeId')
              ?.setValidators(Validators.required);
          }
        }
        for (let i = 0; i < this.dutyChartForm?.value?.dutyRows?.length; i++) {
          if (
            this.dutyChartForm?.value?.dutyRows[i]?.memberTypeId ||
            this.dutyChartForm?.value?.dutyRows[i]?.memberId
          ) {
            this.dutyTableData = this.dutyChartForm?.value?.dutyRows;
          }
        }
      }
    }
  }

  submitForm() {
    if (
      this.editFormData.buttonName === 'Create' ||
      this.editFormData.buttonName === 'Save' ||
      this.editFormData.buttonName === 'Continue Setup'
    ) {
      let apiData;
      if (this.editFormData.buttonName === 'Create' || this.initialMemberRowLen === 1) {
        const addSpinnerRef = this.dialog.open(SpinnerComponent, {
          disableClose: true,
          panelClass: 'transparent-dialog',
        });
        this.dutyTableData?.forEach((obj: any) => {
          Object?.keys(obj)?.forEach((key) => {
            if (obj[key] === '') {
              obj[key] = '0';
            }
          });
        });
        let departmentIds = this.selectedDept?.map(
          (item: { id: any }) => item.id
        );
        let dutyId = this.editFormData?.editId
        apiData = {
          dutyId: dutyId,
          locationId: this.sharedDataService.locationId,
          departmentIds: departmentIds,
          year: this.year,
          month: this.selectedMonthInt,
          memberTypes: this.dutyTableData,
          active: this.enableDutyMap,
        };
        this.dutiesService.saveMappingDuty(apiData).subscribe({
          next: (data: any) => {
            if (data.status === 201) {
              this.dialogRef.close('success');
            }
            addSpinnerRef.close();
          },
          error: (error: any) => {
            addSpinnerRef.close();
          },
        });
      } 
      else if (this.editFormData.buttonName === 'Save') {
        const editSpinnerRef = this.dialog.open(SpinnerComponent, {
          disableClose: true,
          panelClass: 'transparent-dialog',
        });
        this.dutyTableData = this.dutyTableData?.map(
          (item: { memberId: any }) => {
            if (item.memberId) {
              return {
                ...item,
                memberTypeId: item.memberId,
                memberId: item.memberId,
              };
            }
            return item;
          }
        );
        apiData = {
          locationDepartmentDutyId: this.dutyDeptId,
          year: this.year,
          month: this.selectedMonthInt,
          memberTypes: this.dutyTableData,
          active: this.enableDutyMap,
        };
        this.dutiesService.updateMappedDuty(apiData).subscribe({
          next: (data: any) => {
            if (data.status === 204) {
              this.dialogRef.close('success');
              editSpinnerRef.close();
            }
          },
          error: (error: any) => {
            editSpinnerRef.close();
          },
        });
      } else if (this.editFormData.buttonName === 'Continue Setup') {
        if (this.configManually) {
          this.showMemberData = true;
          // this.editFormData.button === 'Save';
          this.editFormData.button = 'duties.map_duty_dialog.action.save_btn';
          this.editFormData.buttonName = 'Save';
          this.memberTypeTable();
        } else {
          this.loadMemberDataOfPrevMonth();
        }
      }
    } else if (this.editFormData.buttonName == 'Close') {
      //to close the form on modal close button on footer
      this.onNoClick();
    }
  }

  // Normalize ID from memberTypeId value (could be string or object)
  private extractMemberTypeId(value: any): string {
    if (!value) return '';
    if (typeof value === 'string') return value;

    // Support both `{ id: '123' }` and `{ memberTypeId: '123' }`
    return value.id || value.memberTypeId || '';
  }

  selectedShiftTypeMemberCombinations(): { memberTypeId: string; memberId: string }[] {
    const rows = (this.dutyChartForm.get('dutyRows') as FormArray).controls;
    return rows
      .map(group => ({
        memberTypeId: this.extractMemberTypeId(group.get('memberTypeId')?.value),
        memberId: this.extractMemberTypeId(group.get('memberId')?.value),//on initial checks the memberTypeId contains name, so we need memberId for id comparison
      }))
      .filter(item => !!item.memberTypeId);
  }

  // Disable MEMBER if memberId is already used in another row
  isMemberTypeDisabledForShift(memberTypeId: any): boolean {
    const normalizedMemberTypeId = this.extractMemberTypeId(memberTypeId);
    // disable memberType if already used in any row
    if (this.availableShiftTypes.length === 1) {
      return (this.dutyChartForm.get('dutyRows') as FormArray).controls.some(row => {
        const rowMemberTypeId = this.extractMemberTypeId(row.get('memberId')?.value ?? row.get('memberTypeId')?.value);// since it uses memberType name in some cases, check for memberId, if it is empty then look for memberTypeId
        return rowMemberTypeId === normalizedMemberTypeId;
      });
    }
    // disable only if same memberId  exists
    return this.selectedShiftTypeMemberCombinations().some(combo => {
     const memberId = combo?.memberId ? combo.memberId : combo.memberTypeId;
     return memberId === normalizedMemberTypeId
    });
  }

  dutyInfo(_dutyId:string) {
    this.dutiesService
    .fetchSingleDutyById(this.editFormData.editId)
    .subscribe({
      next: (response) => {
        if (response?.status === 200 && response.body) {
          this.isManager = response?.body?.managersDuty == true ? response?.body?.managersDuty : null;
          this.getMemberTypeData();
          this.getFormData();
        } 
      },
      error: (err) => {}
    });
  }

  editDuty() {
    this.dutiesService
      .fetchSingleDutyById(this.editFormData.editId)
      .subscribe((dutyDetails) => {
        if (dutyDetails.status === 200) {
          let dialogData;
          dialogData = {
            button: 'duties.create_duty_dialog.action.edit_btn',
            title: 'duties.create_duty_dialog.title.edit_title',
            editData: dutyDetails.body,
            selectedShiftType: this.selectedDutyDetails?.shiftType,
            buttonName: 'Update',
            ...(this.editFormData.globalEdit ? { globalEdit: true } : {}),
            ...((this.editFormData?.isEditDutyReadOnlyDepAdmin === true) ? { isEditDutyReadOnlyDepAdmin : true } : { } ) 
          };
          const createDialogRef = this.dialog.open(DutyDetailsComponent, {
            width: '488px',
            height: '578px',
            disableClose: true,
            data: dialogData,
          });
          createDialogRef.afterClosed().subscribe((result) => {
            // Handle form data returned from dialog
            if (result === 'success') {
              if(this.editFormData?.comparePlanDateDept){
                this.planningDataService.setScheduleApiCallData(true)
              }
              //when closing the dialog modal it should call the duty get api inorder to update the edited duty details
              this.dutiesService
                .fetchSingleDutyById(this.editFormData.editId)
                .subscribe((dutyDetails) => {
                  if (dutyDetails.status === 200) {
                    const body = dutyDetails.body;

                    if (body.name && typeof body.name === 'string' && Array.isArray(body.shifts)) {
                      const matchedShift = body.shifts.find(
                        (shift: any) => shift.shiftDutyId === this.editFormData.editId
                      );

                      // fallback to full day if specific shift not found
                      const shiftToUse = matchedShift || body.shifts.find(
                        (shift: any) => shift.shiftType === 'FULL_DAY_DUTY'
                      );

                      this.selectedDutyDetails = {
                        ...body,
                        firstSlotStartTime: this.sharedDataService.convertTo24HourFormat(shiftToUse?.firstSlotStartTime),
                        firstSlotEndTime: this.sharedDataService.convertTo24HourFormat(shiftToUse?.firstSlotEndTime),
                        secondSlotStartTime: this.sharedDataService.convertTo24HourFormat(shiftToUse?.secondSlotStartTime),
                        secondSlotEndTime: this.sharedDataService.convertTo24HourFormat(shiftToUse?.secondSlotEndTime),
                      };

                      this.selectedDutyName = this.selectedDutyDetails.name;
                    }

                    this.editFormData.refreshDuties();
                  }
                });
            } 
          });
        }
      });
  }

  onOptionChange(event: any) {
    this.selectedDept = event.value;
    this.selectedDeptLength = this.selectedDept.length;
  }

  //add new row to member type table
  addRow() {
    this.validMemberRow = false
    const newRow = this._formBuilder.group({
      memberTypeId: new FormControl('', Validators.required),
      monday: new FormControl('', customPatternValidator('numeric', 'monday')),
      tuesday: new FormControl(
        '',
        customPatternValidator('numeric', 'tuesday')
      ),
      wednesday: new FormControl(
        '',
        customPatternValidator('numeric', 'wednesday')
      ),
      thursday: new FormControl(
        '',
        customPatternValidator('numeric', 'thursday')
      ),
      friday: new FormControl('', customPatternValidator('numeric', 'friday')),
      saturday: new FormControl(
        '',
        customPatternValidator('numeric', 'saturday')
      ),
      sunday: new FormControl('', customPatternValidator('numeric', 'sunday')),
      active: new FormControl('true'),
    });
    this.dutyRows.push(newRow);
    // Give Angular time to render the new row and Auto-Scroll to Newly Added Row
    setTimeout(() => {
      const lastRow = this.rowElements.last;
      if (lastRow) {
        lastRow.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const memberTypeInput = this.memberTypeSelects.last;
        if (memberTypeInput) {
          memberTypeInput.focus(); //focuses the mat-select (does not open it)
        }
      }
    });
    this.dataSource = new MatTableDataSource(this.dutyRows.controls);
    this.editMemberType.push(true) //show member type drop down field
  }

  initiateNewRowForm(): FormGroup {
    return this._formBuilder.group({
      memberTypeId: new FormControl('', Validators.required),
      monday: new FormControl(''),
      tuesday: new FormControl(''),
      wednesday: new FormControl(''),
      thursday: new FormControl(''),
      friday: new FormControl(''),
      saturday: new FormControl(''),
      sunday: new FormControl(''),
    });
  }


  onOptionSelection(event?: MatSelectChange, rowIndex?: number): void {
    const selectedMemberTypeId = event?.value;

    if (!selectedMemberTypeId || rowIndex === undefined) return;
    if (!this.dutyRows || !this.dutyRows.at(rowIndex)) return;

    const currentRow = this.dutyRows.at(rowIndex);
    const currentRowValue = currentRow.value;

    // Clear selectedValues if needed
    if (!this.selectedValues) this.selectedValues = [];

    // If only one shift type, patch directly
    currentRow.patchValue({
      memberTypeId: selectedMemberTypeId,
    });

    // Check and update selectedValues
    this.checkAndTrackCompletedMemberType(selectedMemberTypeId);
    return;
  }

  private checkAndTrackCompletedMemberType(memberTypeId: string): void {
    const normalizedId = this.extractMemberTypeId(memberTypeId);
    const allRows = (this.dutyChartForm.get('dutyRows') as FormArray).controls;

    const usedShiftsForMember = allRows
      .filter(group => this.extractMemberTypeId(group.get('memberTypeId')?.value) === normalizedId)
      .filter(shift => shift); // exclude undefined/null

    const uniqueUsedShifts = [...new Set(usedShiftsForMember)];
    const totalAvailableShifts = this.availableShiftTypes.filter(
      (s) => s
    ).length;

    // Add to selectedValues if all shifts are used
    if (
      uniqueUsedShifts.length === totalAvailableShifts &&
      !this.selectedValues.includes(normalizedId)
    ) {
      this.selectedValues.push(normalizedId);
    }
  }


  isOptionDisabled(value?: string): boolean {
    return this.selectedValues.includes(value);
  }

  deleteRow(data: any, index: any, element: any) {
    this.dutyRows.removeAt(index);
    this.dutyTableData.splice(1, index);
    this.onOptionSelection();
    this.dataSource = new MatTableDataSource(this.dutyRows.controls);
    this.onDayInputChange();
  }

  deleteMemberRow(id: string) {
    this.initialMemberRowLen = this.dutyChartForm?.value?.dutyRows?.length
    this.dutiesService.removeMemberTypeStatus(id).subscribe({
      next: (deleteResp: any) => {
        if (deleteResp.status === 204) {
          this.hasRowRemoved = true;
          this.dutyTableData = this.dutyTableData.filter(
            (item: any) => item.id !== id
          );
          const index = this.dutyRows.controls.findIndex(
            (control: AbstractControl) => (control as FormGroup).value.id === id
          );

          if (index !== -1) {
            this.dutyRows.removeAt(index);
            this.dutyTableData.splice(1, index);
            this.editMemberType.splice(index, 1);      // remove corresponding boolean
            this.editMode.splice(index, 1); 
            this.showMemberRowDelete.splice(index, 1); 
          }
          
          this.dataSource = new MatTableDataSource(this.dutyRows.controls);
          this.noSavedConfigurations = this.dutyRows.length === 0;
        }
      },
      error: () => {
      },
    });
  }

  onActiveMemberChange(event: any, element: any, index: any) {
    this.activeMember = event;
    let apiData = {
      active: this.activeMember,
    };
    this.dutiesService
      .updateMemberTypeStatus(element.value['id'], apiData)
      .subscribe((statusResponse) => {
        if (statusResponse.status === 204) {
          this.dutiesService
            .fetchMonthYearMemberData(
              this.editFormData.editDutyId,
              this.selectedMonthInt,
              this.year
            )
            .subscribe((memberTypeData) => {
              if (memberTypeData.status === 200) {
                if (memberTypeData.body) {
                  if (memberTypeData?.body?.dutyMemberTypes.length > 0) {
                    this.planningSheetPublished =
                      memberTypeData?.body?.planningSheetPublished !== null
                        ? memberTypeData?.body?.planningSheetPublished
                        : false;
                    this.planningSheetSaved =
                      memberTypeData?.body?.planningSheetSaved !== null
                        ? memberTypeData?.body?.planningSheetSaved
                        : false;
                    this.editMemberData = memberTypeData.body.dutyMemberTypes;
                    this.showMemberRowDelete = this.editMemberData.map(
                      () => true
                    );
                    this.editMemberDataForm(true, 'showName');
                  }
                }
              }
            });
        }
      });
  }

  manageMemberType(event: Event) {
    event.stopPropagation();
    let dialogData = {
      title: 'duties.manage_member-type-dialog.title',
      subTitle: 'duties.manage_member-type-dialog.sub_title1',
      listTitle: 'duties.manage_member-type-dialog.sub_title2',
      label: 'duties.manage_member-type-dialog.content.label',
      formData: this.memberTypeList,
      errorMsg:
        'duties.manage_member-type-dialog.content.error_message.duplicate_error',
      type: 'memberType',
    };
    const dialogRef = this.dialog.open(ManageDialogComponent, {
      width: '420px',
      height: '596px',
      disableClose: true,
      data: dialogData,
    });
    let apiData;
    dialogRef.componentInstance.updateDataEvent.subscribe((result: any) => {
      apiData = {
        organisationId: result.organisationId,
        memberType: result.name,
        orderOfListing: result.orderOfListing,
        active: result.active,
        isManager: result.isManager
      };
      this.dutiesService
        .updateMemberType(result.editId, apiData)
        .subscribe((updateData: any) => {
          if (updateData.status === 204) {
            this.getMemberTypeData(dialogRef);
          }
        });
    });
    dialogRef.componentInstance.deleteDataEvent.subscribe((deleteData: any) => {
      let result = deleteData.deleteData
      apiData = {
        organisationId: result.organisationId,
        memberType: result.name,
      };
      this.dutiesService.deleteMemberType(result).subscribe((saveData: any) => {
        if (saveData.status === 204) {
          this.getMemberTypeData(dialogRef);
        }
      });
    });
    dialogRef.componentInstance.addDataEvent.subscribe((result: any) => {
      apiData = {
        orderOfListing: result.orderOfListing,
        organisationId: result.organisationId,
        memberType: result.name,
        active: result.active,
        isManager: result.isManager,
      };
      this.dutiesService.saveMemberType(apiData).subscribe((saveData: any) => {
        if (saveData.status === 201) {
          this.getMemberTypeData(dialogRef);
        }
      });
    });
    dialogRef.componentInstance.cancelUpdateEvent.subscribe((result: any) => {
      this.getMemberTypeData();
    });

    dialogRef.componentInstance.orderingDataEvent.subscribe((result: any) => {
      this.dutiesService
        .reorderMemberType(result)
        .subscribe((saveData: any) => {
          if (saveData.status === 204) {
            this.getMemberTypeData(dialogRef);
            dialogRef.componentInstance.closeDialog('success');
          } else {
            this.dialogRef.close('failure');
          }
        });
    });
    dialogRef.afterClosed().subscribe((result) => {
      // Handle form data returned from dialog
    });
  }

  enableMapping(checked: boolean) {
    this.enableDutyMap = checked;
    this.onDayInputChange();
    this.dutyChartForm.markAsDirty();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDayInputChange(){
    // Define the relevant keys
    const weekDays = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday',
    ];
    //ensure atleast one day of each object in this.dutyChartForm.value.dutyRows have a value
    this.validMemberRow = this.dutyChartForm.value.dutyRows.every((obj:any) =>
      weekDays.some((day) => {
        const dayValue = parseInt(obj[day], 10); // Convert the value to a number
        return !isNaN(dayValue) && dayValue >= 1; // Ensure at least one value is >= 1
      })
    );
  }
}
